import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input , Pipe, PipeTransform, Output, EventEmitter , ViewEncapsulation,AfterViewInit,SimpleChanges, OnChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, FormGroup,UntypedFormControl } from '@angular/forms';
import { interval, Subscription, Subject } from 'rxjs';
import { debounceTime, map, distinctUntilChanged } from 'rxjs/operators';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { ActivatedRoute, Router } from '@angular/router';
import { VendorService } from '../../services/vendor.service';
import { GlobalsService } from '../../services/globals.service';
import { PrintService } from '../../services/print.service';
import { PaymentsService } from '../../services/payments.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { trigger, state, style, transition, animate , query, group, stagger } from '@angular/animations';
import { Location } from '@angular/common'

import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as FileSaver from 'file-saver';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { MatDialog } from '@angular/material/dialog';
import { TransactionGlModalComponent, TransactionGlModalData } from '../../shared/transaction-gl-modal/transaction-gl-modal.component';
import {
	VendorRemitPreviewModalComponent,
	VendorRemitPreviewModalData,
	VendorRemitPreviewTabRequest,
} from '../../shared/vendor-remit-preview-modal/vendor-remit-preview-modal.component';

@Component({
	selector: 'app-vendor-transactions',
	templateUrl: './vendor-transactions.component.html',
	styleUrls: ['./vendor-transactions.component.scss'],
	animations: [
	  trigger('flipState', [
		  state('active', style({
			  transform: 'rotateY(-179deg)'
		  })),
		  state('inactive', style({
			  transform: 'rotateY(0)'
		  })),
		  transition('active => inactive', animate('500ms ease-out')),
		  transition('inactive => active', animate('500ms ease-in'))
	  ]),
	  trigger('openClose', [
		  state(':enter', style({ height: '*' })),
		  state(':leave', style({ height: '0px' })),
		  transition('false <=> true', animate(500))
	  ]),
		trigger('grow', [ // Note the trigger name
		  transition(':enter', [
			// :enter is alias to 'void => *'
				style({ height: '0',width: '0', overflow: 'hidden' }),
				animate(200, style({ height: '*' , width: '*' })),
				animate('200ms', style({ opacity: 1 })),
		  ]),
		  transition(':leave', [
			// :leave is alias to '* => void'
				animate(100, style({ height: 0, width: 0 , overflow: 'hidden' })),
				animate('100ms', style({ opacity: 0 }))
		  ])
		]),
	  trigger('simpleFadeAnimation', [
		  state('in', style({ opacity: 1 })),
		  transition(':enter', [
			  style({ opacity: 0 }),
			  animate('300ms', style({ opacity: 1 }))
		  ]),
		  transition(':leave', [
				animate('100ms', style({ opacity: 0 }))
		  ])
		]),
	]
})
export class VendorTransactionsComponent implements OnInit, OnDestroy {

	headercolumns: string[] = [
		'transno',
		'typename',
		'trandate',
		'order_',
		'totalamount',
		'allocated',
		'balance',
		'settled',
		//'suppname',
		//'address1',
		//'telephone'
	];

	@Input() vendor: any = false;
	@Output() editing = new EventEmitter<boolean>();
	@Output() newvendordata = new EventEmitter<boolean>();
	@ViewChild('details') detailsRef: ElementRef;
	@ViewChild('allocations') allocationsRef: ElementRef;
	@ViewChild('tablecontent') tablecontentRef: ElementRef;

	@ViewChild(MatSort, { static: false }) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	transactions: any = [];
	alltransactions: any = [];
	pagedTransactions: any[] = [];
	pageSize = 50;
	pageIndex = 0;
	pageSizeOptions: number[] = [25, 50, 100, 250, 500];

	// The PDF/XLS exports scrape the rendered table, so they have to see every row, not
	// just the page on screen. This flips the table over to the full list for the one
	// tick it takes to read innerHTML back.
	exportingAll = false;
	displaydetails: any = false;
	sending = false;
	reversalInFlight = false;

	totalAmountSum = 0;
	totalAllocSum = 0;
	totalBalanceSum = 0;

	keywords = new UntypedFormControl('')

	fromdateCtrl = new UntypedFormControl('')
	todateCtrl = new UntypedFormControl('')
	todate = new Date();
	fromdate = new Date();
	opentrans = new UntypedFormControl(true);


	type_filters = [
		{ value: 20, name: 'Invoice' },
		{ value: 21, name: 'Credit' },
		{ value: 22, name: 'Payment' },
	];

	flip = 'inactive';
	type_selected: any = '';
	transidtype: any =false;
	transid: any =false;

	attachmentsTran: any = null;
	attachmentList: any[] = [];
	attachmentsLoading = false;
	selectedAttachment: any = null;
	selectedAttachmentSafeUrl: SafeResourceUrl | null = null;
	currency_default: string = '';
	isMoov = false;
	isClv = false;

	routeSubscription: Subscription;
	opentransSubscription: Subscription;

	constructor(private route: ActivatedRoute, private fb: UntypedFormBuilder, private vendorService: VendorService, public router: Router, private location: Location, private globalsService: GlobalsService, private modalService: NgbModal, private printService: PrintService, private globalSearchService: GlobalSearchService, private sanitizer: DomSanitizer, private dialog: MatDialog, private paymentsService: PaymentsService, private cdr: ChangeDetectorRef) { }

	ngOnInit(): void {

		this.globalSearchService.configsubscription.subscribe((r: any) => {
			this.isMoov = r?.env?.client === 'moov' || r?.env?.client === 'moov_sandbox';
			// no multiple reversals for clv - bad
			// this.isClv = r?.env?.client === 'prod' && r?.env?.package === 'tires';
		});

		const today = new Date();
		const priorDate = new Date(new Date().setMonth(today.getMonth() - 6));
		this.fromdate = priorDate;
		this.type_selected = [20,21,22]

		this.fromdateCtrl.setValue(this.fromdate)
		this.todateCtrl.setValue(this.todate)

		this.routeSubscription = this.route.params.subscribe(params => {
			const supplierid = params['id'];
			if (supplierid) {
				if (!this.vendor) {
					this.vendor = { supplierid };
				} else if (this.vendor.supplierid !== supplierid) {
					this.vendor.supplierid = supplierid;
				}
			}
			this.updateTransactions();
		});

		// Set up debounced search for keywords
		this.keywordSubscription = this.keywords.valueChanges.pipe(
			debounceTime(300),
			distinctUntilChanged()
		).subscribe(() => {
			this.updateTransactions();
		});

		this.opentransSubscription = this.opentrans.valueChanges.pipe(
			distinctUntilChanged()
		).subscribe(() => {
			this.updateTransactions();
		});

	}

	ngOnDestroy() {
		if (this.routeSubscription) {
			this.routeSubscription.unsubscribe();
		}
		if (this.keywordSubscription) {
			this.keywordSubscription.unsubscribe();
		}
		if (this.opentransSubscription) {
			this.opentransSubscription.unsubscribe();
		}
		if (this.hassubscription) {
			this.hassubscription.unsubscribe();
		}
	}

	loadAllocationTo(transid: any, type: any) {
		this.flip = 'active';
		this.transid = transid;
		this.transidtype = type;
	}

	loadAllocations(transid: any, type: any) {
		this.flip = 'active';
		this.transid = transid;
		this.transidtype = type;
	}

	canEditVendorTrans(tran: any): boolean {
		if (tran?.type !== '20' && tran?.type !== '21') {
			return false;
		}
		const settled = String(tran?.settled ?? '');
		if (settled !== '0' && settled !== 'false') {
			return false;
		}
		const alloc = parseFloat(tran?.allocated || '0');
		if (alloc !== 0) {
			return false;
		}
		return true;
	}

	editingTran: any = null;
	editSaving = false;
	editForm = this.fb.group({
		id: [0],
		supplierid: [''],
		transno: [''],
		typename: [''],
		suppreference: ['', Validators.required],
		trandate: ['', Validators.required],
		duedate: [''],
		ovamount: [0, [Validators.required]],
		ovgst: [0],
		ovfee: [0],
	});

	openEditModal(tran: any, content: any) {
		this.editingTran = tran;
		const ovgst = parseFloat(tran.ovgst ?? 0);
		const ovfee = parseFloat(tran.ovfee ?? 0);
		const total = parseFloat(tran.totalamount ?? 0);
		const ovamount = tran.ovamount != null ? parseFloat(tran.ovamount) : (total - ovgst - ovfee);

		const formatDate = (dateStr: any) => {
			if (!dateStr) return '';
			const s = String(dateStr).trim();
			if (s.length >= 10 && /^\d{4}-\d{2}-\d{2}/.test(s)) {
				return s.slice(0, 10);
			}
			const d = new Date(dateStr);
			if (!isNaN(d.getTime())) {
				const yyyy = d.getFullYear();
				const mm = String(d.getMonth() + 1).padStart(2, '0');
				const dd = String(d.getDate()).padStart(2, '0');
				return `${yyyy}-${mm}-${dd}`;
			}
			return '';
		};

		this.editForm.patchValue({
			id: tran.id,
			supplierid: tran.supplierno || this.vendor?.supplierid || '',
			transno: tran.transno,
			typename: tran.typename,
			suppreference: tran.suppreference || '',
			trandate: formatDate(tran.trandate),
			duedate: formatDate(tran.duedate),
			ovamount: ovamount,
			ovgst: ovgst,
			ovfee: ovfee,
		});
		this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'lg' });
	}

	saveEditUnsettled() {
		if (this.editForm.invalid || this.editSaving) {
			return;
		}
		const val = this.editForm.value;
		this.editSaving = true;
		this.vendorService.editUnsettledTransaction(val).subscribe((res: any) => {
			this.editSaving = false;
			if (res && res.success) {
				this.modalService.dismissAll();
				// The server reports what it did with the G/L (a balanced delta journal was
				// posted for an amount change, or the tax breakdown could not be restated).
				// Show its message rather than a blanket "updated" so a partial outcome is
				// never hidden behind a green toast.
				const note = res.message || 'Transaction updated successfully.';
				const level = res.tax_breakdown_skipped ? 'warning' : 'success';
				this.globalSearchService.showNotification(note, level, 'bottom', 'right');
				this.updateTransactions();
			} else {
				const msg = (res && res.message) || 'Failed to update transaction.';
				this.globalSearchService.showNotification(msg, 'danger', 'bottom', 'right');
			}
		}, (err: any) => {
			this.editSaving = false;
			const msg = err?.error?.message || err?.message || 'Error updating transaction.';
			this.globalSearchService.showNotification(msg, 'danger', 'bottom', 'right');
		});
	}

	canReverseVendorTrans(tran: any): boolean {
		if (tran?.type !== '20' && tran?.type !== '21') {
			return false;
		}
		//bypass for CLV to do multiple reversals
		if(this.isClv){
			return true;
		}
		const ref = String(tran?.suppreference || '').trim();
		// Legacy reversal doc marker
		if (ref !== '' && ref.toUpperCase().startsWith('REVERSAL ')) {
			return false;
		}
		// Original already reversed — suppreference carries -R1 / -R2 … suffix
		if (ref !== '' && /\-R\d+$/i.test(ref)) {
			return false;
		}
		const tt = String(tran?.transtext || '').trim();
		if (tt.length > 0 && tt.toLowerCase().startsWith('reversal of doc #')) {
			return false;
		}
		if (tt.length > 0 && tt.toLowerCase().startsWith('reversal id=')) {
			return false;
		}
		return true;
	}

	hasBeenReversed(tran: any): boolean | string{
		const ref = String(tran?.suppreference || '').trim();
		if (ref !== '' && ref.toUpperCase().startsWith('REVERSAL ')) {
			return ref;
		}
		// Original already reversed — suppreference carries -R1 / -R2 … suffix
		if (ref !== '' && /\-R\d+$/i.test(ref)) {
			return ref;
		}
		const tt = String(tran?.transtext || '').trim();
		if (tt.length > 0 && tt.toLowerCase().startsWith('reversal of doc #')) {
			return tt;
		}
		if (tt.length > 0 && tt.toLowerCase().startsWith('reversal id=')) {
			return tt;
		}
		return false;
	}

	reverse(trans: any) {
		if (!this.canReverseVendorTrans(trans)) {
			return;
		}
		if (this.reversalInFlight) {
			return;
		}
		if (!confirm('Reverse transaction #' + trans.transno + '? A matching offsetting document will be created and linked. This cannot be undone.')) {
			return;
		}

		let bypass_duplicate_reversal = false;
		let msg = 'Reason for reversal';
		let prefill = 'Correction';
		
		const pastcontext = this.hasBeenReversed(trans)
		if(pastcontext){
			msg = "Previous reversal information: " + '\n\n' + '  -' + pastcontext + '\n\n' + `Reason for reversal of reversal (Required*): `;
			prefill = '';
			bypass_duplicate_reversal = true
		}

		const reason = prompt(msg, prefill);
		if (reason == null) {
			return;
		}
		const trimmed = String(reason).trim();
		if (!trimmed) {
			this.globalSearchService.showNotification('A reason is required.', 'warning', 'bottom', 'right');
			return;
		}
		this.reversalInFlight = true;
		this.sending = true;
		this.vendorService.reverseTransaction(trans.id, trimmed, bypass_duplicate_reversal).subscribe((result: any) => {
			this.reversalInFlight = false;
			this.sending = false;
			if (result?.success) {
				this.globalSearchService.showNotification('Transaction reversed successfully.', 'success', 'bottom', 'right');
				this.updateTransactions();
			} else {
				this.globalSearchService.showNotification(result?.error || 'Reversal failed.', 'danger', 'bottom', 'right');
			}
		}, (error: any) => {
			this.reversalInFlight = false;
			this.sending = false;
			const msg = error?.error?.error || error?.message || 'Error reversing transaction.';
			this.globalSearchService.showNotification(msg, 'danger', 'bottom', 'right');
		});
	}

	calculateTotals() {
		let total = 0;
		let alloc = 0;
		let balance = 0;
		const list = this.transactions;
		if (list && list.length) {
			for (let i = 0; i < list.length; i++) {
				const c = list[i];
				const amt = parseFloat(c.totalamount) || 0;
				const al = parseFloat(c.allocated) || 0;
				const bal = c.balance != null ? parseFloat(c.balance) : (amt - al);
				total += amt;
				alloc += al;
				balance += bal;
			}
		}
		this.totalAmountSum = total;
		this.totalAllocSum = alloc;
		this.totalBalanceSum = balance;
	}

	getTransactionTotals() {
		return this.totalAmountSum;
	}

	getAllocTotals() {
		return this.totalAllocSum;
	}

	getBalanceTotals() {
		return this.totalBalanceSum;
	}

	hassubscription: any = false;
	keywordSubscription: Subscription;
	searching = false;

	searchTransaction(value: string) {
		this.keywords.setValue(value, { emitEvent: false });
		this.searching = true;
		this.updateTransactions();
	}

	onPageChange(event: PageEvent) {
		this.pageIndex = event.pageIndex;
		this.pageSize = event.pageSize;
		this.updatePagedTransactions();
	}

	updatePagedTransactions() {
		if (!this.transactions || !this.transactions.length) {
			this.pagedTransactions = [];
			return;
		}
		const start = this.pageIndex * this.pageSize;
		const end = start + this.pageSize;
		this.pagedTransactions = this.transactions.slice(start, end);
	}

	get displayRows(): any[] {
		return this.exportingAll ? (this.transactions || []) : this.pagedTransactions;
	}

	// Render every row, read the markup back, then put the page view straight again.
	private async captureFullTableHtml(): Promise<string> {
		this.exportingAll = true;
		this.cdr.detectChanges();
		await new Promise(resolve => setTimeout(resolve, 0));
		let html = '';
		try {
			html = this.tablecontentRef.nativeElement.innerHTML;
		} finally {
			this.exportingAll = false;
			this.cdr.detectChanges();
		}
		return html;
	}

	updateTransactions() {
		const supplierid = this.vendor?.supplierid || this.route.snapshot?.params['id'];
		if (!supplierid) {
			return;
		}
		const search = {
			fromdate : this.fromdateCtrl.value,
			todate : this.todateCtrl.value,
			supplierid: supplierid,
			opentrans: this.opentrans.value,
			types: this.type_selected,
			keywords: this.keywords.value
		};
		this.sending = true;
		if(this.hassubscription) {
			this.hassubscription.unsubscribe();
		}
		this.hassubscription = this.vendorService.getVendorTransactions(search).subscribe( (results: any) => {
			const list = results.transactions != null ? results.transactions : results;
			this.alltransactions = list;
			this.transactions = list;
			this.calculateTotals();
			this.pageIndex = 0;
			this.updatePagedTransactions();
			if (results.currency_default) {
				this.currency_default = results.currency_default;
			}
			if (results.aged && this.vendor) {
				this.vendor.aged = results.aged;
			}
			this.sending = false;
			this.searching = false;
		}, () => {
			this.sending = false;
			this.searching = false;
		});

	}

	back(): void {
		this.editing.emit(false);
	}

	openDocument(transaction: any, content: any, display: string) {

		console.log(transaction.type);
		switch (transaction.type) {
		case '21':
			this.globalsService.getVendorCreditNote(transaction.id, display).subscribe((r: any) => {
				this.displaydetails = r;
				this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
			})
			break;
		case '20':
			this.globalsService.getVendorInvoice(transaction.id, display).subscribe((r: any) => {
				this.displaydetails = r;
				this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
			})

			break;
		}
	}


	openAttachments(tran: any, content: any) {
		this.attachmentsTran = tran;
		this.attachmentList = [];
		this.selectedAttachment = null;
		this.attachmentsLoading = true;
		this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then(() => {
			this.selectedAttachment = null;
			this.selectedAttachmentSafeUrl = null;
		}, () => {
			this.selectedAttachment = null;
			this.selectedAttachmentSafeUrl = null;
		});
		this.vendorService.getVendorAttachments(tran.id).subscribe((r: any) => {
			this.attachmentList = r?.attachments || [];
			this.attachmentsLoading = false;

			if (this.attachmentList.length === 1) {
				const only = this.attachmentList[0];
				if (this.isPdf(only) || this.isImage(only)) {
					this.viewAttachment(only);
				}
			}
		}, () => {
			this.attachmentsLoading = false;
		});
	}

	viewAttachment(att: any) {
		this.selectedAttachment = att;
		this.selectedAttachmentSafeUrl = att ? this.sanitizer.bypassSecurityTrustResourceUrl(this.getAttachmentViewUrl(att)) : null;
	}

	clearAttachmentView() {
		this.selectedAttachment = null;
		this.selectedAttachmentSafeUrl = null;
	}

	isPdf(att: any): boolean {
		const mime = (att?.mime_type || '').toLowerCase();
		const name = (att?.filename || '').toLowerCase();
		return mime === 'application/pdf' || name.endsWith('.pdf');
	}

	isImage(att: any): boolean {
		const mime = (att?.mime_type || '').toLowerCase();
		return mime.startsWith('image/');
	}

	getAttachmentUrl(att: { file_url?: string; id: number }): string {
		if (att?.file_url && (att.file_url.startsWith('http://') || att.file_url.startsWith('https://'))) {
			return att.file_url;
		}
		return this.vendorService.getVendorAttachmentDownloadUrl(att?.id);
	}

	getAttachmentViewUrl(att: any): string {
		if (att?.file_url && (att.file_url.startsWith('http://') || att.file_url.startsWith('https://'))) {
			return att.file_url;
		}
		return this.vendorService.getVendorAttachmentViewUrl(att?.id);
	}

	openGl(transaction: any) {
		this.globalsService.getTransactionGl(transaction.transno, transaction.type).subscribe((r: any) => {
			this.dialog.open(TransactionGlModalComponent, {
				width: '1160px',
				maxWidth: '98vw',
				panelClass: 'gl-preview-dialog-panel',
				data: {
					title: r?.title ?? 'GL transactions',
					lines: r?.data ?? [],
					documentTypeId: transaction.type,
					documentTransno: transaction.transno,
				} as TransactionGlModalData,
			});
		});
	}

	viewPayments(transaction: any, content: any) {
		this.globalsService.getSupplierHowPaid(transaction.id, transaction.type).subscribe((r: any) => {

			this.displaydetails = r;
			this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});

		})
	}

	getTotal(column: string): number {
	  if (!this.displaydetails?.data) {return 0;}
	  return this.displaydetails.data.reduce((total, row) => {
			return total + (parseFloat(row[column]) || 0);
	  }, 0);
	}

	isDifferentCurrency(tran: any): boolean {
		return !!(tran?.currcode && this.currency_default && tran.currcode !== this.currency_default && tran.totalamount_home != null);
	}


	viewAllocations(transaction: any, content: any) {
		this.globalsService.getVendoorAllocationsWType(transaction.id, transaction.type).subscribe((r: any) => {

			this.displaydetails = r;
			this.modalService.open(this.detailsRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});

		})
	}

	/**
	 * MOOV only: open the brand Payout Breakdown for this payment in the same
	 * professional preview modal the remit uses, with PDF / XLSX export.
	 */
	openBrandStatement(transaction: any): void {
		if (!transaction?.id || transaction.type != 22) { return; }
		const paymentId = +transaction.id;
		this.vendorService.getBrandStatementPdfBlobByPayment(paymentId).subscribe((blob: Blob) => {
			FileSaver.saveAs(blob, 'payout-breakdown-' + paymentId + '.pdf');
		});
	}

	/** MOOV only: download the per-payment Payout Breakdown as XLSX (same numbers as the PDF). */
	openBrandStatementXlsx(transaction: any): void {
		if (!transaction?.id || transaction.type != 22) { return; }
		const paymentId = +transaction.id;
		this.vendorService.getBrandStatementXlsxBlobByPayment(paymentId).subscribe((blob: Blob) => {
			FileSaver.saveAs(blob, 'payout-breakdown-' + paymentId + '.xlsx');
		});
	}

	/**
	 * MOOV only: download the brand running Statement of Account (the court-defense
	 * record — every order, collected / remitted / outstanding) as a PDF.
	 */
	openBrandAccount(): void {
		const supplierid = this.vendor?.supplierid || '';
		if (!supplierid) { return; }
		this.vendorService.getBrandAccountPdfBlob(supplierid).subscribe((blob: Blob) => {
			FileSaver.saveAs(blob, 'statement-of-account-' + supplierid + '.pdf');
		});
	}

	/** MOOV only: download the running Statement of Account as XLSX (same numbers as the PDF). */
	openBrandAccountXlsx(): void {
		const supplierid = this.vendor?.supplierid || '';
		if (!supplierid) { return; }
		this.vendorService.getBrandAccountXlsxBlob(supplierid).subscribe((blob: Blob) => {
			FileSaver.saveAs(blob, 'statement-of-account-' + supplierid + '.xlsx');
		});
	}

	/**
	 * Re-open the remit preview for an already-posted vendor payment.
	 * Server side reconstructs supplier + allocations from the payment id alone,
	 * so this works on any historical payment without needing context from the row.
	 */
	viewRemit(transaction: any) {
		if (!transaction?.id || transaction.type != 22) { return; }

		const supplierid = transaction.supplierno || this.vendor?.supplierid || '';
		const paymentId = +transaction.id;
		const paymentType = 'Payment Details';

		// Build a tab that pulls its preview from the dedicated by-payment-id endpoint.
		// We pass an empty allocations array because the modal's request will be
		// overridden — we open the modal directly with the live HTML response below.
		const ref = this.paymentsService.getVendorRemitByPaymentId(paymentId).subscribe((res: any) => {
			if (!res || !res.success || !res.html) {
				const msg = (res && res.message) || 'No remit data found for this payment.';
				this.globalSearchService.showNotification(msg, 'info', 'bottom', 'right');
				return;
			}
			// Hand the rebuilt context to the modal so it re-renders consistently.
			const tab: VendorRemitPreviewTabRequest = {
				label: paymentType,
				supplier_id: supplierid,
				context: {
					payment_total: Math.abs(parseFloat(transaction.ovamount ?? transaction.totalamount ?? '0')) || 0,
					payment_discount: 0,
					payment_reference: transaction.suppreference || '',
					checkno: transaction.checknum || '',
					payment_type: paymentType,
					post_date: this.formatRemitDate(transaction.trandate),
					bank_account: '',
					currency: this.vendor?.currcode || 'USD',
				},
				allocations: [],
			};
			this.dialog.open(VendorRemitPreviewModalComponent, {
				width: '760px',
				maxWidth: '98vw',
				data: {
					title: 'Payment Details',
					tabs: [tab],
					prerendered: res,
				} as VendorRemitPreviewModalData,
			});
		});
	}

	private formatRemitDate(d: any): string {
		if (!d) { return new Date().toISOString().slice(0, 10); }
		try {
			return new Date(d).toISOString().slice(0, 10);
		} catch {
			return String(d).slice(0, 10);
		}
	}
	sendemail: any = '';
	emailtrans: any = '';
	// 	sendEmail(transaction: any, forcetype ? ) {
	// 		this.sendemail = '';
	// 		this.emailtrans = transaction;
	// 		if (this.sendemail == '') {
	// 			for (let x = 0; x < this.vendr.branches.length; x++) {
	// 				if (this.customerdata.branches[x].branchcode == transaction.branchcode) {
	// 					this.sendemail = this.customerdata.customer.invoiceemailaddress;
	// 					if (forcetype) {
	// 						this.emailtype = forcetype;
	// 					} else {
	// 						this.emailtype = false;
	// 					}
	// 				}
	// 			}
	// 		}
	//
	// 		this.modalService.dismissAll();
	// 		this.modalService.open(this.emailRef, { ariaLabelledBy: 'modal-title', size: 'md' }).result.then((result) => {}, (reason) => {});
	// 	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['vendor'] && !changes['vendor'].firstChange) {
			const prevId = changes['vendor'].previousValue?.supplierid;
			const currId = changes['vendor'].currentValue?.supplierid;
			if (currId && currId !== prevId) {
				this.updateTransactions();
			}
		}
	}

	ngAfterViewInit() {
	}

	pdf() {
		this.sending = true;
		this.exportPdf();
	}

	async exportPdf() {
		const encoded: string = this.globalSearchService.base64encode(await this.captureFullTableHtml());
		const today = new Date();
		const opentext = (this.opentrans.value) ? 'Show Open Only Yes' : 'Show Open Only No';
		const data = {
			content: encoded,
			landscape: true,
			filename: this.vendor.supplierid + '-Transactions.pdf',
		}

		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
			this.sending = false;
		});
	}

	async excel() {
		this.sending = true;
		const encoded: string = this.globalSearchService.base64encode(await this.captureFullTableHtml());
		const today = new Date();
		const opentext = (this.opentrans.value) ? 'Show Open Only Yes' : 'Show Open Only No';
		const data = {
			content: encoded,
			filename: this.vendor.supplierid + '-Transactions.xlsx',
		}

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.sending = false;
		});
	}

}
